import { connect } from "react-redux";
import { clickClose } from "@/shared/components/photo_gallery/actions";
import Modal from "@/shared/components/photo_gallery/components/modal";

// Component へ渡すパラメータ値
const mapStateToProps = (state) => {
  return {
    photos: state.gallery.filteredPhotos,
    index: state.modal.index,
    total: state.gallery.filteredPhotos.length,
  };
};

// Component へ渡す Action
const mapDispatchToProps = (dispatch) => {
  return {
    clickClose: (...args) => dispatch(clickClose(...args)),
  };
};

// Component へパラメータを渡す
const connected = connect(mapStateToProps, mapDispatchToProps)(Modal);

export default connected;
